export default "__VITE_ASSET__D6CVhnFR__"